import React, { useEffect, useState } from "react";
import axios from "axios";
import "./NewsEvents.css";

import {
    API_BASE_URL,
    getAppFileUrl
} from "../config/apiConfig";


function NewsEvents() {

    const [uploads, setUploads] = useState([]);
    const [loading, setLoading] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | LOAD NOTICES
    |--------------------------------------------------------------------------
    |
    | API:
    | https://sansha.in/api/getNotices.php
    |
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchUploads = async () => {

            try {

                setLoading(true);

                const res = await axios.get(
                    `${API_BASE_URL}/getNotices.php`
                );


                console.log(
                    "NOTICES API RESPONSE:",
                    res.data
                );


                /*
                |--------------------------------------------------------------------------
                | API returns direct array
                |--------------------------------------------------------------------------
                |
                | Example:
                |
                | [
                |   {
                |       id: 1,
                |       name: "Notice",
                |       file_path: "uploads/test.pdf"
                |   }
                | ]
                |
                |--------------------------------------------------------------------------
                */

                if (Array.isArray(res.data)) {

                    setUploads(res.data);

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | API returns { data: [] }
                |--------------------------------------------------------------------------
                */

                if (
                    res.data &&
                    Array.isArray(res.data.data)
                ) {

                    setUploads(res.data.data);

                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | No valid data
                |--------------------------------------------------------------------------
                */

                setUploads([]);


            } catch (error) {

                console.error(
                    "ERROR FETCHING NOTICES:",
                    error
                );

                setUploads([]);

            } finally {

                setLoading(false);

            }

        };


        fetchUploads();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | OPEN NOTICE
    |--------------------------------------------------------------------------
    |
    | getAppFileUrl() automatically converts:
    |
    | uploads/test.pdf
    |
    | to:
    |
    | https://sansha.in/api/uploads/test.pdf
    |
    |--------------------------------------------------------------------------
    */

    const openNotice = (filePath) => {

        if (!filePath) {

            return;

        }


        const url =
            getAppFileUrl(filePath);


        if (!url) {

            return;

        }


        console.log(
            "OPENING NOTICE:",
            url
        );


        window.open(
            url,
            "_blank",
            "noopener,noreferrer"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | RENDER
    |--------------------------------------------------------------------------
    */

    return (

        <section
            className="news-events-section"
            style={{
                background: "transparent"
            }}
        >

            <div className="news-events-container-">


                {/* ================================================= */}
                {/* HEADING */}
                {/* ================================================= */}

                <div className="news-heading">

                    <div className="news-heading-icon">

                        <i className="fa fa-bullhorn"></i>

                    </div>


                    <div>

                        <span className="news-small-title">

                            Sree Padmanabhaswamy Temple

                        </span>


                        <h2>

                            Latest Updates

                        </h2>

                    </div>

                </div>


                {/* ================================================= */}
                {/* HEADING LINE */}
                {/* ================================================= */}

                <div className="news-heading-line">

                    <span></span>

                </div>


                {/* ================================================= */}
                {/* LOADING */}
                {/* ================================================= */}

                {loading && (

                    <div className="news-loading">

                        <div className="news-loader"></div>


                        <span>

                            Loading latest updates...

                        </span>

                    </div>

                )}


                {/* ================================================= */}
                {/* EMPTY MESSAGE */}
                {/* ================================================= */}

                {!loading &&
                    uploads.length === 0 && (

                    <div className="news-empty">

                        <i className="fa fa-info-circle"></i>


                        <span>

                            No latest updates available.

                        </span>

                    </div>

                )}


                {/* ================================================= */}
                {/* NOTICE LIST */}
                {/* ================================================= */}

                {!loading &&
                    uploads.length > 0 && (

                    <div className="news-list">

                        {uploads.map(
                            (item, index) => (

                            <article

                                key={
                                    item.id ||
                                    index
                                }

                                className={
                                    `news-item ${
                                        item.file_path
                                            ? "news-clickable"
                                            : ""
                                    }`
                                }

                                onClick={() => {

                                    if (
                                        item.file_path
                                    ) {

                                        openNotice(
                                            item.file_path
                                        );

                                    }

                                }}

                            >


                                {/* =============================== */}
                                {/* NUMBER */}
                                {/* =============================== */}

                                <div className="news-number">

                                    <span>

                                        {String(
                                            index + 1
                                        ).padStart(
                                            2,
                                            "0"
                                        )}

                                    </span>

                                </div>


                                {/* =============================== */}
                                {/* ICON */}
                                {/* =============================== */}

                                <div className="news-icon">

                                    <i className="fa fa-file-text-o"></i>

                                </div>


                                {/* =============================== */}
                                {/* CONTENT */}
                                {/* =============================== */}

                                <div className="news-content">

                                    <h3>

                                        {
                                            item.name ||
                                            "Latest Update"
                                        }

                                    </h3>


                                    <span className="news-meta">

                                        <i className="fa fa-calendar-o"></i>

                                        &nbsp;

                                        Temple Notification

                                    </span>

                                </div>


                                {/* =============================== */}
                                {/* ARROW */}
                                {/* =============================== */}

                                {item.file_path && (

                                    <div className="news-arrow">

                                        <i className="fa fa-angle-right"></i>

                                    </div>

                                )}

                            </article>

                        ))}

                    </div>

                )}

            </div>

        </section>

    );

}


export default NewsEvents;